<template>
  <ul class="pagination" v-if="response.total > response.per_page">
    <li class="page-item" :class="{disabled: response.current_page === 1}">
      <a class="page-link" @click="previous">Previous</a>
    </li>
    <li
        v-for="number in response.last_page"
        class="page-item"
        :class="{active: response.current_page === number}"
    >
      <a class="page-link" @click="navigateTo(number)">{{ number }}</a>
    </li>
    <li class="page-item" :class="{disabled: response.current_page === response.last_page}">
      <a class="page-link" @click="next">Next</a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "PaginationComponent",
  props: ['response'],
  data: function () {
    return {
      page: null
    }
  },
  methods:{
    previous() {
      const number = this.response.current_page - 1;
      if (this.response.current_page === 1) {return null;}
      this.changePage(number);

    },
    navigateTo(number) {
      this.changePage(number);
    },
    next() {
      const number = this.response.current_page + 1;
      if (this.response.current_page === this.response.last_page) {return null;}
      this.changePage(number);
    },
    changePage(value) {
      this.$emit('setPage', value)
    }
  }
}
</script>

<style scoped>

</style>
